import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconShieldWithStar = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 41,
	height: 42,
	viewBox: "0 0 41 42",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M21.6475 6.1875L33.3975 11.1875C34.7725 11.8125 35.835 13.125 35.835 14.75C35.7725 21 33.21 32.3125 22.46 37.5C21.3975 38 20.21 38 19.1475 37.5C8.39746 32.3125 5.83496 21 5.83496 14.75C5.77246 13.125 6.83496 11.8125 8.20996 11.1875L19.96 6.1875C20.21 6.0625 20.5225 6 20.835 6C21.085 6 21.3975 6.0625 21.6475 6.1875ZM27.8975 19.0625H27.835C28.46 18.5 28.46 17.5625 27.835 16.9375C27.2725 16.375 26.335 16.375 25.7725 16.9375L18.835 23.9375L15.8975 21C15.2725 20.375 14.335 20.375 13.7725 21C13.1475 21.5625 13.1475 22.5 13.7725 23.0625L17.7725 27.0625C18.335 27.6875 19.2725 27.6875 19.8975 27.0625L27.8975 19.0625Z",
			fill: "#107F47"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 23.1079,
			width: 14,
			height: 14,
			rx: 7,
			fill: "#FFB700",
			className: "shieldStar"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.5545 3.14128L31.5913 5.2627L33.8722 5.59766C34.0636 5.62956 34.2231 5.75716 34.2869 5.94857C34.3507 6.12402 34.3029 6.33138 34.1593 6.45898L32.5005 8.10189L32.8993 10.4307C32.9312 10.6221 32.8514 10.8135 32.6919 10.9251C32.5324 11.0527 32.325 11.0527 32.1496 10.973L30.1079 9.8724L28.0503 10.973C27.8908 11.0527 27.6834 11.0527 27.5239 10.9251C27.3644 10.8135 27.2847 10.6221 27.3166 10.4307L27.6994 8.10189L26.0405 6.45898C25.9129 6.33138 25.8651 6.12402 25.9129 5.94857C25.9767 5.75716 26.1362 5.62956 26.3276 5.59766L28.6245 5.2627L29.6453 3.14128C29.7251 2.96582 29.9006 2.85417 30.1079 2.85417C30.2993 2.85417 30.4748 2.96582 30.5545 3.14128Z",
			fill: "white"
		})
	]
});
const ForwardRef = forwardRef(SvgIconShieldWithStar);
export { ForwardRef as ReactComponent };
